import { init_sc_swipers } from './swiper';

(function ($) {

    const $root = $('#sc-products');
    const acf_fields = $root.data('acf_fields');
    const root_category_id = $root.data('root_category_id');
    const current_category_id = $root.data('current_category_id');
    // const query_args = $root.data('query_args');
    

    // Contador de productos
    const $countEl = $root.find('.n-products');

    // Grid principal
    let $gridEl = $root.find('[data-role="grid"]');

    // Botón "Cargar más"
    const $loadMoreBtn = $root.find('[data-role="load-more"]');

    // Botones de filtro (aunque ya no los uses)
    const $filterBtns = $root.find('.filter-btn');

    // Inputs de autor
    const $authorInputs = $root.find('input.js-author');

    // Contenedor de filtros seleccionados
    const $selectedFiltersEl = $root.find('[data-role="selected-filters"]');

    const $authorsBtn = $('#open-authors');
    const $authorsContainer = $('.authors-container');

  
    // --- helpers ---
    function getAuthorNameById(id) {
        const inp = root.querySelector(`input.js-author[value="${id}"]`);
        if (!inp) return `#${id}`;
        const label = inp.closest('label');
        const p = label ? label.querySelector('p') : null;
        return p ? p.textContent.trim() : `#${id}`;
    }

    function getSubcatLabel(slug) {
        const btn = root.querySelector(`[data-filter="${slug}"]`);
        if (!btn) return slug;
        const span = btn.querySelector('span');
        return (span ? span.textContent : btn.textContent).trim();
    }

    // Renderiza listado de filtros seleccionados
    function renderSelectedFilters() {

        if (!$selectedFiltersEl) return;

        const chips = [];

        // chips de autores
        state.authors.forEach(aid => {
            chips.push({
                kind: 'author',
                value: String(aid),
                label: getAuthorNameById(aid),
            });
        });


        $selectedFiltersEl.html(
            chips.map(c => `
                <button
                    type="button"
                    class="sc-chip-filter"
                    data-role="remove-filter"
                    data-kind="${c.kind}"
                    data-value="${c.value}"
                    title="Remove ${c.label}"
                >
                    <span>${c.label}</span>
                    <i class="w-4 h-4 close-icon"></i>
                </button>
            `).join('')
        );
    }

    // Quitar un chip
    $selectedFiltersEl.click(function(e) {
        const $target = $(e.target);
        const $rm = $target.closest('[data-role="remove-filter"]');
        const $clr = $target.closest('[data-role="clear-all"]');

        if ($clr.length) {
            // Deseleccionar todo
            state.subcat = 'all';
            state.authors = [];

            $authorInputs.prop('checked', false);

            markActiveButton(state.subcat);
            state.paged = 1;
            renderSelectedFilters();
            fetchAndRender();
            return;
        }

        if (!$rm.length) return;

        const kind  = $rm.data('kind');
        const value = $rm.data('value');

        if (kind === 'subcat') {
            state.subcat = 'all';
            markActiveButton('all');
        } else if (kind === 'author') {
            const id = parseInt(value, 10);
            state.authors = state.authors.filter(a => a !== id);

            const $inp = $root.find(`input.js-author[value="${id}"]`);
            if ($inp.length) $inp.prop('checked', false);
        }

        state.paged = 1;
        renderSelectedFilters();
        fetchAndRender();
    });
    


    function onFiltersChanged() {
        state.paged = 1;
        renderSelectedFilters();
        fetchAndRender(false, true);
    }

    // Estado inicial desde URL y data-atributo
    const url0 = new URL(window.location.href);

    const initialAuthors = $root.data('selected-authors')
        ? JSON.parse($root.attr('data-selected-authors'))
        : new URL(window.location.href).searchParams.getAll('author').map(Number);

    let state = {
        subcat: new URL(window.location.href).searchParams.get('subcat') || 'all',
        paged: parseInt(new URL(window.location.href).searchParams.get('paged') || '1', 10) || 1,
        authors: initialAuthors || []
    };

    // Pre-check de inputs según estado
    $authorInputs.each(function() {
        const $input = $(this);
        const id = parseInt($input.val(), 10);
        $input.prop('checked', state.authors.includes(id));
    });

    markActiveButton(state.subcat);
    renderSelectedFilters();

    // Click en filtros
    $filterBtns.click(function(e) {
        e.preventDefault();

        // Scroll suave al inicio del contenedor principal
        const $containerGrid = $('#sc-products');
        const targetY = $containerGrid.offset().top;

        $('html, body').animate({ scrollTop: targetY }, 400); // 400ms = velocidad suave

        // Actualiza el estado
        const $btn = $(this);
        state.subcat = $btn.data('filter') || 'all';
        state.paged  = 1;

        markActiveButton(state.subcat);
        renderSelectedFilters();
        fetchAndRender();
    });


    // Cambio en checkboxes de autores
    $authorInputs.change(function() {
        state.paged = 1;

        // Obtener todos los autores seleccionados
        state.authors = $authorInputs
            .filter(':checked')
            .map(function() {
                return parseInt($(this).val(), 10);
            })
            .get();

        // Actualizar atributo en el contenedor principal
        $root.attr('data-selected-authors', JSON.stringify(state.authors));

        // Llamar al handler general
        onFiltersChanged();
    });

        // --- Estado de carga ---------------------------------------------------
    let isLoading = false;

    /**
     * Placeholders con el componente Skeleton del design system.
     * Ocupan el hueco donde van a aparecer las cards, que es la señal de carga
     * más clara: el usuario ve DÓNDE va a llegar el contenido.
     */
    function skeletonCardsHtml(count) {
        const postType = (acf_fields && acf_fields.post_type) || 'product';
        /* En arte la card ocupa varias pistas de la rejilla; el grid lo dice en data-card_span
           para que el esqueleto mida lo mismo que la card que va a sustituir. */
        const span = $gridEl.attr('data-card_span') || 'col-span-1';
        let html = '';

        for (let i = 0; i < count; i++) {
            html += `
                <div class="loop-card-container ${postType}-card-container mb-sc-spacing-padding-md ${span}" data-role="skeleton" aria-hidden="true">
                    <div class="sc-skeleton sc-skeleton--card w-full aspect-[3/4]"></div>
                    <div class="sc-skeleton h-4 w-2/3 mt-3"></div>
                    <div class="sc-skeleton h-4 w-1/3 mt-2"></div>
                </div>`;
        }

        return html;
    }

    function removeSkeletons() {
        $gridEl.find('[data-role="skeleton"]').remove();
    }


    /**
     * aria-disabled + aria-busy en lugar de `disabled`: `disabled` saca el botón
     * del orden de tabulación, así que quien lo pulsa con teclado pierde el foco
     * y no lo recupera al reactivarse.
     */
    function setLoading(loading, append) {
        isLoading = loading;

        if ($loadMoreBtn.length) {
            $loadMoreBtn.attr('aria-disabled', loading ? 'true' : 'false');
            $loadMoreBtn.attr('aria-busy', loading ? 'true' : 'false');
        }

        if (!loading) {
            removeSkeletons();
            return;
        }

        // Solo al añadir: al filtrar se reemplaza el grid entero.
        if (append) {
            const perPage = parseInt(acf_fields && acf_fields.num_products, 10) || 12;
            $gridEl.append(skeletonCardsHtml(perPage));
        }
    }

    // Botón cargar más
        $loadMoreBtn.click(function() {
        if (isLoading) return;
        state.paged += 1;
        fetchAndRender(true, false); // no tocar URL al cargar más
    });

    // Mostrar/ocultar el botón según páginas restantes
    function updateLoadMoreVisibility(totalPages) {
        if (!$loadMoreBtn.length) return;

        const noMore = !totalPages || state.paged >= totalPages;
        $loadMoreBtn.prop('hidden', noMore);
    }

    // Actualiza la URL solo al cambiar filtros (subcat/autores), no al “cargar más”
    function updateAddressBar({ subcat, authors, paged }) {
        const url = new URL(window.location.href);

        if (subcat && subcat !== 'all') url.searchParams.set('subcat', subcat);
        else url.searchParams.delete('subcat');

        // opcional: si prefieres no guardar paginación en la URL, comenta estas dos líneas:
        if (paged && paged > 1) url.searchParams.set('paged', String(paged));
        else url.searchParams.delete('paged');

        url.searchParams.delete('author');
        (authors || []).forEach(a => url.searchParams.append('author', String(a)));

        history.pushState({}, '', url.toString());
    }

    // Click en paginación (delegado)
    // root.addEventListener('click', (e) => {
    //   const a = e.target.closest('a.page-numbers');
    //   if (!a || !paginationEl.contains(a)) return;
    //   const page = parseInt(a.getAttribute('data-page'), 10);
    //   if (!page) return;
    //   e.preventDefault();
    //   state.paged = page;
        
    //   fetchAndRender();
    // });

    function fetchAndRender(append = false, pushState = true) {

        if (pushState) {
            updateAddressBar({
                subcat: state.subcat,
                paged: state.paged,
                authors: state.authors
            });
        }

        const action_type = append ? 'load_more' : 'filter';

        // La query se reconstruye en servidor (ver inc/ajax-requests/filter-products.php);
        // desde aquí solo viaja la configuración del bloque y la página pedida.
        let formData = {
            action: 'sc_filter_products',
            nonce: window.translations.loop_nonce,
            // Como JSON en un solo parámetro: si se manda como objeto, jQuery lo
            // serializa en cientos de claves y PHP lo trunca por max_input_vars
            // (block_card llegaba incompleto). Además así se preservan los tipos.
            acf_fields: JSON.stringify(acf_fields),
            action_type: action_type,
            paged: state.paged,
            root_category_id: root_category_id,
            current_category_id: current_category_id,
        }

        // Mandar autores seleccionados (formData es un objeto plano, no un FormData)
        if (state.authors && state.authors.length) {
            formData['authors[]'] = state.authors.map(String);
        }

        $.ajax({
            url: window.translations.ajax_url,
            type: 'POST',
            data: formData,
            beforeSend: function() {
                setLoading(true, append);
            },
            success: function(response) {

                if (!response || !response.success) {
                    console.error('AJAX failed');
                    return;
                }

                const { grid_html, found_posts, current, total_pages } = response.data;
            
                // Actualiza el grid
                  if (append) {

                    // Quitar los placeholders antes de insertar, para que las
                    // cards reales ocupen su sitio sin que el grid dé un salto.
                    removeSkeletons();
                    $gridEl.append(grid_html);
                    
                // Reemplaza grid completo
                } else {
                    $gridEl.replaceWith(grid_html);
                    // replaceWith deja $gridEl apuntando al nodo desconectado:
                    // sin esto, los "load more" posteriores no pintarían nada.
                    $gridEl = $root.find('[data-role="grid"]');
                }

                $countEl.text(found_posts);
                updateLoadMoreVisibility(total_pages);

                lucide.createIcons();

                init_sc_swipers($gridEl);

                /* Las cards que llegan por AJAX no pasan por el arranque de init.js, y
                   sus imágenes nacen con opacity: 0 hasta que alguien les pone `.loaded`.
                   Sin esto, "cargar más" añade cards invisibles. */
                if (typeof window.markLoopImagesLoaded === 'function') {
                    window.markLoopImagesLoaded($gridEl);
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error:', status, error);
            },
            complete: function() {
                // Limpia también si la petición ha fallado.
                setLoading(false, append);
            }
        });
    }


    function markActiveButton(slug) {
        $filterBtns.each(function() {
            const $btn = $(this);
            const filter = $btn.data('filter');
            const active =
                (slug === 'all' && (filter === 'all' || !filter)) ||
                filter === slug;

            $btn.attr('data-active', active ? 'true' : 'false');
            $btn.toggleClass('underline', active);
        });
    }

    // Navegación del navegador (botón atrás/adelante)
    $(window).on('popstate', function() {
        const url = new URL(window.location.href);

        state.subcat = url.searchParams.get('subcat') || 'all';
        state.paged  = parseInt(url.searchParams.get('paged') || '1', 10) || 1;

        // Actualizar autores desde la URL
        const authorsFromUrl = url.searchParams.getAll('author').map(Number);
        state.authors = authorsFromUrl;

        // Actualizar inputs de autor
        $authorInputs.each(function() {
            const $input = $(this);
            const id = parseInt($input.val(), 10);
            $input.prop('checked', state.authors.includes(id));
        });

        // Guardar estado en el atributo del root
        $root.attr('data-selected-authors', JSON.stringify(state.authors));

        markActiveButton(state.subcat);
        renderSelectedFilters();
        fetchAndRender();
    });


    // primer render (reemplazo)
    // fetchAndRender(false, false);

    // Botón mostrar autores
    $authorsBtn.click(function() {
        $authorsContainer.toggleClass('open');
        $authorsBtn.toggleClass('open');
    });
    

})(jQuery);